import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { Select, Icon, Avatar } from "antd";
import { connect } from "react-redux";

import { debounce } from "../../utils/debounce";

import UsersService from "../../services/user";

import DefaultUserImage from "../../assets/img/avatar_user_black.png";
import { ReactComponent as AddSvg } from "../../assets/icon/ic_add_24dp.svg";
import { ReactComponent as CancelSvg } from "../../assets/icon/ic_cancel_24dp.svg";
import { ReactComponent as WarningSvg } from "../../assets/icon/ic_warning_24dp.svg";

import "./SelectReceivers.scss";

const Option = Select.Option;

function SelectedUsers({
  users,
  onClose,
  disabled,
  getUserAvatar,
  profiles,
  formatMessage,
  initialRecipients,
}) {
  let localSelectedUsers = [];

  users = Array.isArray(users) ? users : Object.values(users);

  for (let i in users) {
    let user = users[i];

    if (user.user) {
      user = {
        ...user.user,
        isActive: user.isActive,
      };
    }

    localSelectedUsers.push(
      <div className="selected-user" key={user.username}>
        <Avatar src={getUserAvatar(user)} />

        <div className="selected-user-block">
          {profiles?.includes(user.username) ? (
            <span className="selected-user-username">
              @{formatMessage({ id: `profiles.${user.username}` })}
            </span>
          ) : (
            <span className="selected-user-username">@{user.username}</span>
          )}

          {!user.isActive && (
            <span className="selected-user-inative">
              <FormattedMessage id="chat.disabledUser" />
            </span>
          )}
        </div>

        <div className="selected-user-icon-container">
          {user.away ? <Icon className="away" component={WarningSvg} /> : false}

          {disabled || initialRecipients?.includes(user.username) ? (
            false
          ) : (
            <Icon
              className="filled-button"
              component={CancelSvg}
              onClick={(e) => onClose(e, user.username)}
            />
          )}
        </div>
      </div>
    );
  }

  return localSelectedUsers;
}

class SelectReceivers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedUsers: {},
      usersToSelect: [],
      value: [],
      inputValue: "",
    };

    this.onSelect = this.onSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getNotFoundContentString = this.getNotFoundContentString.bind(this);
    this.onClose = this.onClose.bind(this);
    this.setListRef = this.setListRef.bind(this);
  }

  componentDidMount() {
    const { draft } = this.props;

    if (draft && draft.recipients) {
      this.setState({
        selectedUsers: draft.recipients,
      });
    }

    if (this.props.recipients) {
      let selectedUsers = this.props.recipients.reduce((obj, item) => {
        const key = item.username || item.user?.username || item.id;
        obj[key] = item;
        return obj;
      }, {});

      this.setState({
        selectedUsers: selectedUsers,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { draft, profiles } = this.props;
    const defaultCategory = window.Social.getChatConfig().defaultCategory;

    if (
      prevProps.draft?.category !== defaultCategory &&
      draft?.category === defaultCategory
    ) {
      const dataProfiles = profiles.map((elem) => {
        return elem;
      });

      this.removeRecipients(dataProfiles);
    }
  }

  componentWillUnmount() {
    this.debounceChange.clear();
  }

  handleSearch(value) {
    this.debounceChange(value);
  }

  debounceChange = debounce((value) => {
    const { formatMessage } = this.props.intl;
    const { category } = this.props.draft || {};

    const defaultCategory = window.Social.getChatConfig().defaultCategory;

    if (value.length > 0) {
      const params = {
        name: value,
        enabled: true,
      };

      let profiles = [];

      if (category !== defaultCategory) {
        profiles =
          this.props.profiles?.map((elem) => {
            return {
              id: elem,
              name: formatMessage({ id: `profiles.${elem}` }),
              username: elem,
              isActive: true,
            };
          }) || [];

        profiles = profiles.filter((elem) => {
          return (
            elem.name?.toLowerCase().includes(value.toLowerCase()) ||
            elem.id.toLowerCase().includes(value.toLowerCase())
          );
        });
      }

      UsersService.getUsers(params).then((res) => {
        const currentUserLogin = this.props.currentUser?.login;

        let suggestions = res?.data?.content
          .filter((user) => user.username !== currentUserLogin)
          .map((user) => {
            return {
              ...user,
              isActive: true,
            };
          });

        suggestions = [].concat(profiles, suggestions);

        this.setState({
          usersToSelect: suggestions,
          inputValue: value,
        });
      });

      return;
    }

    this.setState({
      usersToSelect: [],
      inputValue: value,
    });
  }, 500);

  onSelect(value, option) {
    let localSelectedUsers = this.removeReactivity(this.state.selectedUsers);

    localSelectedUsers[option.key] = this.state.usersToSelect.find(
      (elem) => elem.username === option.key
    );

    this.props.onSelectedUsersChange?.(localSelectedUsers);

    this.setState({
      selectedUsers: localSelectedUsers,
      usersToSelect: [],
      inputValue: "",
    });
  }

  onClose(e, username) {
    e.stopPropagation();

    this.removeRecipients([username]);
  }

  removeRecipients(usernames) {
    let localSelectedUsers = this.removeReactivity(this.state.selectedUsers);

    usernames.forEach((username) => {
      delete localSelectedUsers[username];
    });

    this.props.onSelectedUsersChange?.(localSelectedUsers);

    this.setState({
      selectedUsers: localSelectedUsers,
    });
  }

  removeReactivity(obj) {
    return JSON.parse(JSON.stringify(obj));
  }

  setListRef(node) {
    this.listRef = node;
  }

  getStatus(user) {
    if (user && !user.away) {
      return false;
    }

    return <Icon className="away" component={WarningSvg} />;
  }

  getUserAvatar(user) {
    return DefaultUserImage;
  }

  getNotFoundContentString() {
    return this.state.inputValue && this.state.inputValue.length > 0 ? (
      <FormattedMessage id="chat.userNotFound" />
    ) : (
      <FormattedMessage id="chat.typeUserName" />
    );
  }

  render() {
    const { profiles } = this.props;
    const { formatMessage } = this.props.intl;

    const options = this.state.usersToSelect
      ?.filter((user) => {
        const isAlreadySelected = !!this.state.selectedUsers[user.username];
        const searchValue = this.state.inputValue.toLowerCase();
        const displayName = profiles?.includes(user.username)
          ? formatMessage({ id: `profiles.${user.username}` })
          : user.username;
        const matchesSearch =
          !searchValue ||
          displayName?.toLowerCase().includes(searchValue) ||
          user.name?.toLowerCase().includes(searchValue) ||
          user.username?.toLowerCase().includes(searchValue);

        return !isAlreadySelected && matchesSearch;
      })
      .map((user) => {
        const displayName = profiles?.includes(user.username)
          ? formatMessage({ id: `profiles.${user.username}` })
          : user.username;

        return (
          <Option
            key={user.username}
            username={"@" + displayName}
            name={user.name}
            value={"@" + displayName + " - " + user.name}
          >
            <Avatar src={this.getUserAvatar(user)} />

            <div className="user-description">
              <span className="title">@{displayName}</span>

              <span className="description">{user.name}</span>

              {this.getStatus(user)}
            </div>
          </Option>
        );
      });

    return (
      <div className="select-receivers">
        <div className="selected-users">
          <SelectedUsers
            users={this.state.selectedUsers}
            onClose={this.onClose}
            disabled={this.props.disabled}
            getUserAvatar={this.getUserAvatar}
            profiles={this.props.profiles}
            formatMessage={this.props.intl.formatMessage}
            initialRecipients={this.props.initialRecipients}
          />
        </div>

        <div className="input-user">
          <Icon className="plus-icon" component={AddSvg} />

          <Select
            mode="multiple"
            value={this.state.value}
            style={{ width: "100%" }}
            placeholder={<FormattedMessage id="chat.sendTo" />}
            notFoundContent={this.getNotFoundContentString()}
            optionLabelProp="username"
            dropdownMatchSelectWidth={false}
            dropdownClassName="select-receivers-dropdown"
            getPopupContainer={() => this.listRef}
            disabled={this.props.disabled}
            filterOption={false}
            onSelect={this.onSelect}
            onSearch={this.handleSearch}
          >
            {options}
          </Select>

          <div className="dropdown-container" ref={this.setListRef} />
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  currentUser: state.Users.currentUser,
}))(injectIntl(SelectReceivers));
